<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户联系人</el-breadcrumb-item>
    </el-breadcrumb>
    <UserList></UserList>
  </div>
</template>
<script>
import UserList from './list'
export default {
  components: {
    UserList,
  },
}
</script>